import { useTranslation } from "react-i18next";
import { array, number, object, string } from "yup";

import { PROJECT_DESC_LIMIT } from "../constants";

// Validation regex: allows Chinese, English, numbers, dot (.), and hyphen (-)
// Prohibits: spaces, tabs, special characters (@, #, etc.)
const CLASSIFY_CATEGORY_REGEX = /^[a-zA-Z0-9\u4e00-\u9fa5.-]+$/;
const MAX_CLASSIFY_TAGS = 10;

export const ProjectInfoSchema = () => {
    const { t } = useTranslation();

    const schema = {
        id: string().required(),
        title: string().required(`${t("COMMON.Required_Input")}`),
        description: string()
            .required(`${t("COMMON.Required_Input")}`)
            .max(PROJECT_DESC_LIMIT, `${t("COMMON.Word_Limit")}  ${PROJECT_DESC_LIMIT.toString()} `),
        image_url: string().nullable(),
        top_k: number().required(),
        min_embed_score: number().required(),
        max_context_token: number().required(),
        max_history_token: number().required(),
        max_resp_token: number().required(),
        classify_category_tags: array()
            .of(
                object().shape({
                    tag: string()
                        .required(t("PROJECT.CLASSIFY_CATEGORY_REQUIRED") || "標籤內容不可為空")
                        .test(
                            "no-empty-string",
                            t("PROJECT.CLASSIFY_CATEGORY_REQUIRED") || "標籤內容不可為空",
                            (value) => {
                                // Reject empty strings or whitespace-only strings
                                return value ? value.trim() !== "" : false;
                            }
                        )
                        .test(
                            "no-invalid-chars",
                            t("PROJECT.CLASSIFY_CATEGORY_INVALID_CHARS") ||
                                "只允許中文、英文、數字、點(.)和連字號(-)，不允許空格和特殊符號",
                            (value) => {
                                // Only validate format if value exists and is not empty
                                if (!value || value.trim() === "") return false;
                                return CLASSIFY_CATEGORY_REGEX.test(value);
                            }
                        ),
                })
            )
            .max(MAX_CLASSIFY_TAGS, t("PROJECT.CLASSIFY_CATEGORY_MAX_TAGS") || `最多 ${MAX_CLASSIFY_TAGS} 個標籤`)
            .optional(),
    };

    return object().shape(schema);
};

export const projectNameSchema = (isInit: boolean) => {
    const schema = {
        ...(!isInit && { project_title: string().required() }),
    };

    return object().shape(schema);
};
